controllers.controller('UpdatePasswordController', [
    '$scope', '$ionicHistory', '$state', '$ionicLoading',
    'config', 'constants', 'ErrorService', 'UserService', 'LoginService', 'LocaleService', 'API',
    'Validator', 'Utils', 'UserControl',
    function ($scope, $ionicHistory, $state, $ionicLoading,
              config, Const, ErrorService, UserService, LoginService, LocaleService, API,
              Validator, Utils, UserControl) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.navigate = function (state) {
            $state.go(state);
        };
        $scope.user = UserService.get();
        $scope.validator = Validator.getPattern;

        $scope.auth = {
            password: ''
        };

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            actionText: LocaleService.translation.try_again,
            back: ''
        };

        $scope.modal = angular.copy(modalDefaults);

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'UpdatePasswordController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.changePassword = function (form) {
            Utils.formRevalidate(form);
            if (!form.$valid) return;

            var request = {
                oldPassword: $scope.auth.oldPassword,
                newPassword: $scope.auth.password
            };

            $ionicLoading.show();

            return API.changePassword(request)
                .then(checkResponse)
                .then(function () {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.password_changed;
                    $scope.modal.actionText = LocaleService.translation.close;
                    $scope.modal.isError = false;
                    $scope.modal.textContent = '';
                    $scope.modal.back = "root.app.menu";
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.err_password_changed;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.password_err_changed_text;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.state = true;
                })
        };

        $scope.$on('$ionicView.beforeEnter', function () {
            var user = UserService.get();
            $scope.state = UserControl.getState();

            if (user && user.liveAccountExists) {
                return
            }

            if ($scope.state) {
                return $state.go($scope.state, {cache: false});
            }

            if ($scope.user && !$scope.user.tnc && Const['tncPopup']) {
                return $state.go('tnc', {cache: false});
            }

            if ($scope.user) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }
                return UserService.kycCheck();
            }
        });
    }]);
